var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.task.done)?_c('div',{staticClass:"tasks-list-item__loader"},[_c('span',{staticClass:"el-icon-loading"})]):(_vm.task.success)?_c('div',{staticClass:"tasks-list-item__complete-status success"},[_c('span',{staticClass:"el-icon-success"})]):_c('div',{staticClass:"tasks-list-item__complete-status error"},[_c('span',{staticClass:"el-icon-error"})])
}
var staticRenderFns = []

export { render, staticRenderFns }